import Activity from 'react-feather/dist/icons/activity';
const ThreadsIcon = Activity;
export default ThreadsIcon;

